import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import {
  Skeleton,
  Table,
  Drawer,
  Button,
  Card,
  Divider,
  Menu,
  Dropdown,
  Icon,
  notification,
} from 'antd';
import { TopoPagina } from '../componentes';
import FormRegistroAgendamentoRpa from './FormRegistroAgendamentoRpa';

import { tableLocale } from '../../common/configConstants';

export class AgendamentoRpa extends Component {
  static propTypes = {
    loginSap: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      drawerVisible: false,
    };
  }

  componentDidMount() {
    const { actions } = this.props;

    actions.listarAgendamentoRpa();
  }
  componentDidUpdate(prevProps) {
    const { loginSap, actions } = this.props;

    if (prevProps.loginSap.listarAgendamentoRpaPending && !loginSap.listarAgendamentoRpaPending) {
      if (loginSap.listarAgendamentoRpaError) {
        notification.error({ message: 'Falha ao buscar registros.' });
      }
    }

    if (prevProps.loginSap.buscarAgendamentoRpaPending && !loginSap.buscarAgendamentoRpaPending) {
      if (loginSap.buscarAgendamentoRpaError) {
        notification.error({ message: 'Falha ao buscar registro.' });
      }
    }

    if (prevProps.loginSap.salvarAgendamentoRpaPending && !loginSap.salvarAgendamentoRpaPending) {
      if (loginSap.salvarAgendamentoRpaError) {
        notification.error({ message: 'Falha ao salvar registro.' });
      } else {
        this.setState({ drawerVisible: false });
        actions.listarAgendamentoRpa();
      }
    }
  }

  handleSubmit = form => {
    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }
      this.salvarRegistro(values);
    });
  };

  salvarRegistro = registro => {
    const { loginSap, actions } = this.props;

    actions.salvarAgendamentoRpa(loginSap.registroAgendamentoRPA.id, registro);
  };
  showDrawer = registro => {
    const { actions } = this.props;

    actions.buscarAgendamentoRpa(registro.id);
    this.setState({ drawerVisible: true });
  };
  closeDrawer = () => {
    const { actions } = this.props;

    actions.inicializarRegistroLoginSap();
    this.setState({ drawerVisible: false });
  };

  render() {
    const { loginSap } = this.props;
    const { drawerVisible } = this.state;
    const colunas = [
      {
        title: 'Rotina RPA',
        dataIndex: 'Nome',
        key: 'Nome',
      },
      {
        title: 'Login',
        dataIndex: 'SAP_User',
        key: 'SAP_User',
      },
      {
        title: 'Ambiente SAP',
        dataIndex: 'SAP_Ambiente',
        key: 'SAP_Ambiente',
      },
      {
        title: 'Ações',
        dataIndex: '',
        key: 'x',
        render: (text, record) => {
          return (
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item key="1" onClick={() => this.showDrawer(record)}>
                    Editar
                  </Menu.Item>
                </Menu>
              }
            >
              <Button>
                Ações <Icon type="down" />
              </Button>
            </Dropdown>
          );
        },
      },
    ];

    return (
      <div className="login-sap-agendamento-rpa">
        <TopoPagina titulo="Configuração de Impersonate SAP" />
        <Skeleton active loading={loginSap.listarAgendamentoRpaPending}>
          <div className="containerPage">
            <div className="containerConteudo">
              <Table
                dataSource={loginSap.listaAgendamentoRPA}
                columns={colunas}
                size="small"
                bordered
                style={{ paddingTop: '15px' }}
                loading={loginSap.listarAgendamentoRpaPending}
                locale={tableLocale}
              />
            </div>
          </div>
        </Skeleton>

        <Drawer
          placement="right"
          visible={drawerVisible}
          title="Cadastro de Impersonate SAP"
          onClose={() => this.closeDrawer()}
          width={'40vw'}
          closable={false}
          destroyOnClose={true}
        >
          <Card
            extra={
              <React.Fragment>
                <Button onClick={() => this.closeDrawer()} type="primary" icon="rollback">
                  Cancelar
                </Button>
                <Divider type="vertical" />
                <Button
                  onClick={() => this.formRef.props.onSubmit()}
                  type="primary"
                  icon="save"
                  loading={loginSap.salvarAgendamentoRpaPending}
                >
                  Salvar
                </Button>
              </React.Fragment>
            }
          >
            <FormRegistroAgendamentoRpa
              registro={loginSap.registroAgendamentoRPA}
              submitForm={this.handleSubmit}
              formRef={el => (this.formRef = el)}
            />
          </Card>
        </Drawer>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    loginSap: state.loginSap,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AgendamentoRpa);



// WEBPACK FOOTER //
// ./src/features/login-sap/AgendamentoRpa.js